// Functions
import {
  findAncestor,
  slideDown,
  slideUp,
  isWebp,
  buttomBtnInit,
  initGetBonusMobileBtn,
} from "./modules/functions.js";

// Plugins
import "./include/jquery.form.min.js";
import "./include/jquery.jgrowl.min.js";
import "./include/jquery.datetimepicker.full.min.js";
import "./include/swiper.js";
import "./include/popper.min.js";
import "./include/tippy.min.js";
import "./include/img-lightbox.js";
import Wow from "wow.js";

// Modules
// with jQuery
import "./jquery-scripts.js";
import "./modules/modalOld.js";
import "./modules/select.js";
import "./modules/datetimepicker.js";
import "./modules/stickyScroll.js";
import "./modules/search.js";
import "./modules/user.js";
import "./modules/timer.js";
import "./modules/htmlEditor.js";
import "./modules/forecastVote.js";
import "./modules/footerCountrySelect.js";
import "./modules/bkFilter.js";
import "./modules/calcRoi.js";
import "./modules/polls.js";
import "./modules/matches.js";
import "./modules/bestBk.js";
import "./modules/custom.js";
import "./modules/shedule.js";
import "./modules/changeLog.js";
import "./modules/compare.js";
import "./modules/history.js";
import "./modules/ajaxload.js";

// vanilla JS
import "./modules/swInit.js";
import "./modules/noscriptLoad.js";
import "./modules/tooltips.js";
import "./modules/sliders.js";
import "./modules/svgRadials.js";
import "./modules/passwordIndicator.js";
import "./modules/goTop.js";
import "./modules/lazyloadImages.js";
import "./modules/horizontalScroll.js";

document.addEventListener("DOMContentLoaded", function (event) {
  initGetBonusMobileBtn();

  const burgerBtn = document.querySelector("#burgerBtn");
  const mask = document.querySelector(".mask");
  const socialBtn = document.querySelector(".social__btn");
  const social = document.querySelector(".social");
  const mainRightFilter = document.querySelector(".main__right--filter");
  const filterBox = document.querySelector(".sidebar.filter");
  const html = document.querySelector("html");

  // Табы в таблице рейтинга
  const ozorBtns = document.querySelectorAll(".obzor__open");
  ozorBtns.forEach((ozorBtn) => {
    ozorBtn.addEventListener("click", () => {
      const currParentLine = findAncestor(ozorBtn, "best__table__line");
      currParentLine.classList.toggle("best__table__line--active");
    });
  });

  const sidebarNews = document.querySelectorAll(".sidebar__new--toggle");

  if (sidebarNews) {
    sidebarNews.forEach((sidebarNew) => {
      sidebarNew.addEventListener("mouseenter", () => {
        const sidebarNewBody = sidebarNew.querySelector(".sidebar__new__body");
        slideDown(sidebarNewBody, 300);

        if (sidebarNew.classList.contains("sidebar__new--simple")) {
          sidebarNew.classList.add("sidebar__new--border");
        }
      });

      sidebarNew.addEventListener("mouseleave", () => {
        const sidebarNewBody = sidebarNew.querySelector(".sidebar__new__body");
        slideUp(sidebarNewBody, 300);

        if (sidebarNew.classList.contains("sidebar__new--simple")) {
          sidebarNew.classList.remove("sidebar__new--border");
        }
      });
    });
  }

  // News
  // Соцсети
  if (socialBtn) {
    socialBtn.addEventListener("click", (evt) => {
      evt.preventDefault();
      social.classList.toggle("social--active");
      socialBtn.classList.toggle("social__btn--active");

      if (window.innerWidth < 1200) {
        mask.classList.toggle("mask--active");
      }
    });
  }

  // Табы в фильтре
  const filterLinesWrapper = document.querySelectorAll(
    ".filter__line__wrapper"
  );
  filterLinesWrapper.forEach((filterLine) => {
    filterLine.addEventListener("click", () => {
      filterLine.parentNode.classList.toggle("filter__line--active");
    });
  });

  // Закрыть фильтр
  const closeFilter = document.querySelector("#closeFilter");

  function closeFilterHandler(evt) {
    if (
      !evt.composedPath().includes(closeFilter) &&
      !evt.composedPath().includes(filterCloseBtn)
    ) {
      if (!evt.composedPath().includes(filterBox)) {
        mainRightFilter.classList.remove("main__right--open");
        filterBox.classList.remove("filter--open");
        html.classList.remove("noscroll");
      }
    } else {
      mainRightFilter.classList.remove("main__right--open");
      filterBox.classList.remove("filter--open");
      html.classList.remove("noscroll");
    }

    mainRightFilter.removeEventListener("click", closeFilterHandler);
  }

  if (closeFilter) {
    closeFilter.addEventListener("click", closeFilterHandler);
  }

  const filterCloseBtn = document.querySelector(".filter__close__btn ");

  if (filterCloseBtn) {
    filterCloseBtn.addEventListener("click", closeFilterHandler);
  }

  // Открыть фильтр
  const openFilter = document.querySelector("#openFilter");
  if (openFilter) {
    openFilter.addEventListener("click", () => {
      mainRightFilter.classList.add("main__right--open");
      filterBox.classList.add("filter--open");
      html.classList.add("noscroll");
      mainRightFilter.addEventListener("click", closeFilterHandler);
    });
  }
  // Переключение вкладок
  const prognozPannelItems = document.querySelectorAll(
    ".prognoz__pannel__item"
  );
  const prognozSeries = document.querySelectorAll(".prognoz__series");

  function resetPrognoz() {
    prognozPannelItems.forEach((prognozPannelItem) => {
      prognozPannelItem.classList.remove("prognoz__pannel__item--current");
    });

    prognozSeries.forEach((prognozSerieslItem) => {
      prognozSerieslItem.classList.remove("prognoz__series--active");
    });
  }

  if (prognozPannelItems) {
    prognozPannelItems.forEach((prognozPannelItem) => {
      prognozPannelItem.addEventListener("click", (evt) => {
        evt.preventDefault();
        resetPrognoz();
        prognozPannelItem.classList.add("prognoz__pannel__item--current");
        const currDataTab = prognozPannelItem.dataset.tab;
        const currSeriesSection = document.getElementById(currDataTab);
        currSeriesSection.classList.add("prognoz__series--active");
      });
    });
  }

  // Читать полностью
  const readMoreList = document.querySelectorAll(".best__link__inner");
  if (readMoreList) {
    readMoreList.forEach((readMoreItem) => {
      readMoreItem.addEventListener("click", (evt) => {
        evt.preventDefault();
        const linkParent = readMoreItem.parentNode;
        const currHiddenText = linkParent.querySelector(".hide");
        currHiddenText.classList.remove("hide");

        readMoreItem.remove();
      });
    });
  }

  // Выбор способа оплаты
  const wholeOptionBtns = document.querySelectorAll(
    ".whole__section__tab__options__btn"
  );
  if (wholeOptionBtns) {
    wholeOptionBtns.forEach((wholeOptionBtn) => {
      wholeOptionBtn.addEventListener("click", (evt) => {
        evt.preventDefault();

        const wholeOptionBtnParent = findAncestor(
          wholeOptionBtn,
          "whole__section__tab__option"
        );
        const wholeOptionBtnsInner = wholeOptionBtnParent.querySelectorAll(
          ".whole__section__tab__options__btn"
        );
        wholeOptionBtnsInner.forEach((wholeOptionBtnInner) => {
          wholeOptionBtnInner.classList.remove(
            "whole__section__tab__options__btn--active"
          );
        });

        wholeOptionBtn.classList.add(
          "whole__section__tab__options__btn--active"
        );
      });
    });
  }

  const copyBtns = document.querySelectorAll(".whole__section__tab__info__btn");
  if (copyBtns) {
    copyBtns.forEach((copyBtn) => {
      copyBtn.addEventListener("click", (evt) => {
        evt.preventDefault();
        const currentCopyItem = findAncestor(
          copyBtn,
          "whole__section__tab__info__value--special"
        );
        const currentText = currentCopyItem.querySelector(
          ".whole__section__tab__info__value__text"
        );
        currentText.select();
        document.execCommand("copy");
      });
    });
  }

  // Закрыть баннер
  const closeBannerBtn = document.querySelector("#closeBanner");
  if (closeBannerBtn) {
    closeBannerBtn.addEventListener("click", (evt) => {
      evt.preventDefault();
      const bannerItem = document.querySelector(".banner__bot");
      bannerItem.style.display = "none";
      buttomBtnInit();
      initGetBonusMobileBtn();
    });
  }

  const sidebarExpertsNavBtns = document.querySelectorAll(
    ".sidebar__experts__nav__btn"
  );
  if (sidebarExpertsNavBtns) {
    sidebarExpertsNavBtns.forEach((sidebarExpertsNavBtn) => {
      sidebarExpertsNavBtn.addEventListener("click", (evt) => {
        evt.preventDefault();

        const sidebarExpertsTables = document.querySelectorAll(
          ".sidebar__experts__table"
        );
        sidebarExpertsTables.forEach((sidebarExpertsTable) => {
          sidebarExpertsTable.classList.remove(
            "sidebar__experts__table--active"
          );
        });

        sidebarExpertsNavBtns.forEach((sidebarExpertsNavBtn) => {
          sidebarExpertsNavBtn.classList.remove(
            "sidebar__experts__nav__btn--active"
          );
        });

        sidebarExpertsNavBtn.classList.add(
          "sidebar__experts__nav__btn--active"
        );

        const expertsTableId = document.querySelector(
          sidebarExpertsNavBtn.dataset.experts
        );
        expertsTableId.classList.add("sidebar__experts__table--active");
      });
    });
  }

  const modalItemsHeader = document.querySelectorAll(
    ".modal__filter__body__item__header"
  );
  if (modalItemsHeader) {
    modalItemsHeader.forEach((modalItemHeader) => {
      modalItemHeader.addEventListener("click", function () {
        const modalFilterBodyItem = findAncestor(
          modalItemHeader,
          "modal__filter__body__item"
        );

        modalFilterBodyItem.classList.toggle(
          "modal__filter__body__item--active"
        );
      });
    });
  }

  let radialProgressDone = document.querySelectorAll(".radial-progress--done");

  if (radialProgressDone) {
    radialProgressDone.forEach(function (element, index) {
      if (!element.querySelector(".complete").classList.contains("completed")) {
        // Get percentage of progress
        let percent = element.dataset.percentage;

        // Get radius of the svgs circle.complete

        let radius = element.querySelector(".complete").getAttribute("r");

        // Get circumference (2πr)

        let circumference = 2 * Math.PI * radius;

        // Get stroke-dashoffset value based on the percentage of the circumference

        let strokeDashOffset = circumference - (percent * circumference) / 100;

        element.querySelector(".complete").style.strokeDashoffset =
          strokeDashOffset;

        element.querySelector(".complete").classList.add("completed");
      }
    });
  }

  const codeCopyBtns = document.querySelectorAll(".js-code-copy");
  if (codeCopyBtns) {
    codeCopyBtns.forEach((copyBtn) => {
      copyBtn.addEventListener("click", (evt) => {
        evt.preventDefault();
        const currentCopyItem = copyBtn.closest(".rating-test__promocode");
        const currentText = currentCopyItem.querySelector(
          ".rating-test__input"
        );
        currentText.select();
        document.execCommand("copy");
      });
    });
  }

  isWebp();

  const mainMenu = document.querySelector("#main-menu");
  const header = document.getElementById("header");
  const searchWrapper = document.querySelector(".search__wrapper");

  function modalClose() {
    const modals = document.querySelectorAll(".modal");

    modals.forEach((modal) => {
      modal.classList.remove("modal--active");
    });

    mask.classList.remove("mask--active");
    html.classList.remove("noscroll");
    searchWrapper.classList.remove("search__wrapper--active");
    header.classList.remove("header--mask");
  }

  function modalOpen(modalId) {
    const modal = document.querySelector(modalId);
    modal.classList.add("modal--active");
    mask.classList.add("mask--active");
    html.classList.add("noscroll");
  }

  window.onkeydown = function (event) {
    if (event.keyCode == 27) {
      modalClose();
    }
  };

  const dataModalIds = document.querySelectorAll("[data-modal-id]");
  if (dataModalIds) {
    dataModalIds.forEach((dataModalId) => {
      dataModalId.addEventListener("click", (evt) => {
        evt.preventDefault();
        modalClose();
        const modalId = dataModalId.dataset.modalId;
        modalOpen(modalId);
      });
    });
  }

  const modalCloseBtns = document.querySelectorAll(".modal__close");
  if (modalCloseBtns) {
    modalCloseBtns.forEach((modalCloseBtn) => {
      modalCloseBtn.addEventListener("click", (evt) => {
        modalClose();
      });
    });
  }

  const jsModalCloseBtns = document.querySelectorAll(".js-modal-close");
  jsModalCloseBtns.forEach((jsModalCloseBtn) => {
    jsModalCloseBtn.addEventListener("click", function (evt) {
      evt.preventDefault();

      modalClose();
    });
  });

  if (mask) {
    mask.addEventListener("click", () => {
      modalClose();
      header.classList.remove("header--mask");

      if (mainMenu.classList.contains("main-menu--active")) {
        mask.classList.remove("mask--down");
        mainMenu.classList.remove("main-menu--active");
        burgerBtn.classList.remove("burger--active");
      }
    });
  }

  const openSearch = document.querySelector("#headerSearchBtn");

  openSearch.addEventListener("click", (evt) => {
    evt.preventDefault();
    searchWrapper.classList.toggle("search__wrapper--active");

    document.querySelector(".search__input").focus();
    mask.classList.toggle("mask--active");
    html.classList.toggle("noscroll");
    header.classList.toggle("header--mask");
    burgerBtn.classList.remove("burger--active");
    mainMenu.classList.remove("main-menu--active");
  });

  if (burgerBtn) {
    burgerBtn.addEventListener("click", (evt) => {
      evt.preventDefault();
      burgerBtn.classList.toggle("burger--active");
      mask.classList.toggle("mask--active");
      mask.classList.toggle("mask--down");
      mainMenu.classList.toggle("main-menu--active");
      html.classList.toggle("noscroll");
    });
  }

  const footerTitles = document.querySelectorAll(".footer__title");
  footerTitles.forEach((footerTitle) => {
    footerTitle.addEventListener("click", () => {
      const parentFooterTitle = footerTitle.parentNode;

      parentFooterTitle.classList.toggle("footer__col--active");
    });
  });

  const dataForecastsTabs = document.querySelectorAll("[data-forecasts-tab]");
  if (dataForecastsTabs) {
    dataForecastsTabs.forEach((dataForecastsTab) => {
      dataForecastsTab.addEventListener("click", (evt) => {
        evt.preventDefault();

        dataForecastsTabs.forEach((dataForecastsTab) => {
          dataForecastsTab.classList.remove(
            "forecasts__detail__nav__item--active"
          );
        });

        dataForecastsTab.classList.add("forecasts__detail__nav__item--active");

        const forecastsTabs = document.querySelectorAll(".forecasts__tab");
        forecastsTabs.forEach((forecastsTab) => {
          forecastsTab.classList.remove("forecasts__tab--active");
        });

        const forecastsTabId = dataForecastsTab.dataset.forecastsTab;
        const forecastsTabCurrent = document.querySelector(forecastsTabId);

        forecastsTabCurrent.classList.add("forecasts__tab--active");
      });
    });
  }

  const customSectionTabBtns = document.querySelectorAll(
    ".custom__section__tab__wrapper"
  );
  if (customSectionTabBtns) {
    customSectionTabBtns.forEach((customSectionTabBtn) => {
      customSectionTabBtn.addEventListener("click", (evt) => {
        evt.preventDefault();
        const customSectionTab = findAncestor(
          customSectionTabBtn,
          "custom__section--tab"
        );
        customSectionTab.classList.toggle("custom__section--active");
      });
    });
  }

  const sidebarTabArrows = document.querySelectorAll(
    ".sidebar--tab .sidebar__title"
  );
  if (sidebarTabArrows) {
    sidebarTabArrows.forEach((sidebarTabArrow) => {
      sidebarTabArrow.addEventListener("click", (evt) => {
        evt.preventDefault();
        const sidebarTab = findAncestor(sidebarTabArrow, "sidebar--tab");
        sidebarTab.classList.toggle("sidebar--active");
      });
    });
  }

  // WOW init
  const wowNodes = document.querySelectorAll(".wow");
  if (wowNodes.length) {
    const wow = new Wow();

    wow.init();
  }
});

imgLightbox("img-lightbox-link");

$(document).on("as_complete", document, function (e, d) {
  imgLightbox("img-lightbox-link");
});
